import type Message from 'owa-service/lib/contract/Message';

const NEEDED_KEYS = [
    'ConversationId',
    'DateTimeReceived',
    'Flag',
    'HasAttachments',
    'IsRead',
    'ItemId',
    'ParentFolderId',
    'Preview',
    'Sender',
    'Subject',
];

/**
 * This function filters out the unnecessary properties from the Message interface that we
 * don't want included in the data sent to the server, because it isn't necessary for rendering and
 * takes up space.
 *
 * Just returning an interface of type Pick<Message, ...NEEDED_KEYS> isn't enough because
 * typescript Pick doesn't actually remove the unneeded properties, so we still write back the extra data
 * @param item
 */
export default function createPayloadObject(item: Message): Message {
    const itemSubset = {} as Message;
    NEEDED_KEYS.forEach(key => {
        itemSubset[key] = item[key];
    });
    return itemSubset;
}
